import { MILESTONE_CATEGORIES } from "@shopify-harness/sdk";
import { z } from "zod";

/**
 * カレンダー画面の URL 状態。month 省略時は「今月」を表す（URL を汚さない）。
 * リンク共有でビューが再現されるよう、月と種別の絞り込みを URL に持たせる（原則 7）。
 */
export const calendarSearchSchema = z.object({
  month: z
    .string()
    .regex(/^\d{4}-(0[1-9]|1[0-2])$/)
    .optional()
    .catch(undefined),
  category: z
    .enum(["all", ...MILESTONE_CATEGORIES])
    .catch("all")
    .default("all")
});

export type CalendarSearch = z.infer<typeof calendarSearchSchema>;
